import { render, staticRenderFns } from "./analytics.vue?vue&type=template&id=b882f0f8&scoped=true&"
import script from "./analytics.vue?vue&type=script&lang=js&"
export * from "./analytics.vue?vue&type=script&lang=js&"
import style0 from "./analytics.vue?vue&type=style&index=0&id=b882f0f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b882f0f8",
  null
  
)

export default component.exports